import cn from 'clsx'
import * as React from 'react'
import { DropTarget } from 'react-dnd'
import { FILE } from '@disco/constants/ItemTypes'
import { getFilesFromDraggedItem } from '@disco/utils/file-utils'
const fileDropTarget = {
  drop(props, monitor) {
    const draggedItem = monitor.getItem()

    if (draggedItem.items) {
      getFilesFromDraggedItem(draggedItem).then((files: File[]) => {
        if (files.length > 0) {
          // Is multiple file drag and drop allowed?
          props.onDrop(props.multiple ? files : [files[0]])
        }
      })
    }
  },
}

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
  }
}

class FileDropWrapper extends React.Component<{
  isOver: boolean
  onOver?: (...args: Array<any>) => any
  multiple?: boolean
  connectDropTarget: (...args: Array<any>) => any
  overlay: React.ReactNode
  children: React.ReactNode
  disabled: boolean | null | undefined
  className?: string
}> {
  render() {
    const { connectDropTarget, isOver, onOver, disabled } = this.props
    if (disabled) return this.props.children

    if (onOver) {
      onOver(isOver)
    }

    return connectDropTarget(
      // `is-over` lets callers style the drop target itself while a file is
      // dragged over it, rather than only dimming its contents.
      <div className={cn(this.props.className, { 'is-over': isOver })}>
        {isOver ? <span>{this.props.overlay}</span> : null}
        <div
          style={{
            opacity: isOver ? 0.5 : 1,
          }}
        >
          {this.props.children}
        </div>
      </div>,
    )
  }
}

export default DropTarget(
  [FILE],
  fileDropTarget,
  collect,
)(FileDropWrapper) as any
